













import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class Payoneer extends Vue {
  private created(): void {
    const code = this.$route.query.code;
    const error = this.$route.query.error;
    const responsePath = this.$route.query.response_path;
    if (code) {
      window.opener && window.opener.MESSENGER.emit('payoneerAuthorize', {
        code: code as string,
      });
      window.close();
      return;
    }
    if (error) {
      window.opener && window.opener.MESSENGER.emit('payoneerAuthorizeError', {});
      window.close();
    }
    if (responsePath) {
      const sessionId = this.$route.query.session_id;
      window.opener && window.opener.MESSENGER.emit('rechargeResult', {
        response_path: responsePath,
        session_id: sessionId,
      });
      window.close();
    }
  }
}
